'use strict';

const $ = require('jquery');
const Cookies = require('../cookie');

let $document = $(document),
    sTrue = 'true',
    sNoCountryCheck = 'NoCountryCheck';

exports.init = function ($container) {
    let $el = $container && $container.length ? $container : $('#countrygateway');

    if ($el && $el.length) {
        $document.on('click', '.closecountrydialog', function () {
            //setNoCheck
            Cookies.set(sNoCountryCheck, sTrue, {path: '/', expires: 730});
        });

        $document.on('change', '.select-country', function (e) {
            let options = '';
            let $currentTarget = $(e.currentTarget);
            let languageCodes = $('option:selected', $currentTarget).data('languagecodes');

            if (languageCodes) {
                /*eslint-disable guard-for-in */
                for (let i = 0; i < languageCodes.length; i++) {
                    options +=
                        '<option value="' +
                        languageCodes[i].languageCode +
                        '">' +
                        languageCodes[i].languageName +
                        '</option>';
                }
                /*eslint-enable guard-for-in */

                $('.select-language', this.$el).html(options);
                $currentTarget.uniform.update();
            }
        });
    }
};
